import styled from 'styled-components'
import Text from 'components.v2/Text'
import colors from 'theme/colors'

export const Wrapper = styled.div`
  display: flex;
  background-color: ${colors['black']};
  min-height: 68px;
  align-items: center;
  position: relative;
  width: 100%;
`
export const Contents = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  flex-direction: row;
  flex: 1;
  max-width: 100%;
`

export const Right = styled.div`
  width: 30px;
  height: 30px;
  margin-left: auto;
`

export const Left = styled.div`
  flex: 1;
  margin-right: auto;
  display: flex;
  align-items: center;
`

export const Avatar = styled.div`
  background-position: center;
  background-size: cover;
  background-color: white;
  border: solid 1px white;
  width: 35px;
  height: 35px;
  border-radius: 50%;
`

export const Description = styled.div`
  flex: 1;
  padding-left: 12px;
  overflow: hidden;
  max-width: 255px;
`
export const Message = styled(Text)`
  font-size: 11px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.82;
  letter-spacing: 0.42px;
  text-transform: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const Title = styled(Text)`
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const MenuActions = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  cursor: pointer;
`

export const MenuActionItems = styled.div`
  width: 245px;
  min-height: 100px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  position: absolute;
  right: 0;
  top: 40px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1000;
`

export const MenuActionItem = styled.button`
  align-items: center;
  color: $black;
  display: flex;
  font-stretch: normal;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  max-height: 50px;
  letter-spacing: normal;
  line-height: 1.43;
  flex: 1;
  padding-left: 33px;

  svg {
    width: 23px;
    height: auto;
    margin-right: 21px;
  }

  svg g {
    fill: ${colors['grayText60']};
  }
`

export const MenuActionItemsMobile = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  padding-right: 15px;
  overflow: hidden;
`

export const MenuActionItemMobile = styled.button`
  align-items: center;
  color: $black;
  display: flex;
  flex: 1;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  letter-spacing: normal;
  line-height: normal;
  min-height: 60px;
  max-height: 60px;

  &:first-child {
    border-bottom: solid 1px ${colors['gray5']};
  }

  svg {
    width: 30px;
    height: auto;
    margin-right: 21px;
  }

  svg g {
    fill: ${colors['grayText60']};
  }

  > div {
    margin-right: 15px;
  }
`

export const MoreButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover,
  &:active {
    background-color: rgba(255, 255, 255, 0.1);
  }

  > div {
    margin-top: -6px;
  }

  path {
    fill: white;
  }
`

export const ShareLink = styled.input`
  color: transparent;
  position: absolute;
  top: -3000px;
  left: -3000px;
`
